export default {
  title: 'Warehouse Management',

  // Search filter area
  search: {
    warehouseCode: 'Warehouse Code',
    warehouseCodePlaceholder: 'Search warehouse code',
    warehouseName: 'Warehouse Name',
    warehouseNamePlaceholder: 'Search warehouse name',
    keyword: 'Keyword Search',
    keywordPlaceholder: 'Warehouse code, name, address, etc.',
    country: 'Country',
    countryPlaceholder: 'Select country',
    language: 'Language',
    languagePlaceholder: 'Select language',
    stateProvince: 'State/Province',
    stateProvincePlaceholder: 'Search state/province',
    city: 'City',
    cityPlaceholder: 'Search city',
    warehouseType: 'Warehouse Type',
    warehouseTypePlaceholder: 'Select warehouse type',
    status: 'Status',
    statusPlaceholder: 'Select status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    searchButton: 'Search',
    resetButton: 'Reset'
  },

  // Action buttons
  actions: {
    addWarehouse: 'Add Warehouse',
    copyFromPlatform: 'Copy Add',
    batchImport: 'Batch Import',
    batchOperation: 'Batch Actions ({count})',
    batchEnable: 'Batch Enable',
    batchDisable: 'Batch Disable',
    batchDelete: 'Batch Delete',
    edit: 'Edit',
    more: 'More',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    enable: 'Enable',
    disable: 'Disable',
    recordsCount: 'Total {count} records'
  },

  // Table columns
  table: {
    warehouseCode: 'Warehouse Code',
    warehouseName: 'Warehouse Name',
    warehouseType: 'Warehouse Type',
    country: 'Country',
    city: 'City',
    address: 'Address',
    dataSource: 'Data Source',
    createdBy: 'Created By',
    modifiedBy: 'Modified By',
    dateCreated: 'Created Time',
    dateModified: 'Modified Time',
    status: 'Status',
    operation: 'Operation',
    languageVersion: 'Language Versions'
  },

  // Form
  form: {
    addTitle: 'Add Warehouse',
    editTitle: 'Edit Warehouse',
    warehouseCode: 'Warehouse Code',
    warehouseCodePlaceholder: 'Please enter warehouse code',
    warehouseType: 'Warehouse Type',
    warehouseTypePlaceholder: 'Select warehouse type',
    warehouseNameCn: 'Warehouse Name (Chinese)',
    warehouseNameCnPlaceholder: 'Please enter Chinese warehouse name',
    warehouseNameEn: 'Warehouse Name (English)',
    warehouseNameEnPlaceholder: 'Please enter English warehouse name',
    country: 'Country',
    countryPlaceholder: 'Select country',
    stateProvince: 'State/Province',
    stateProvincePlaceholder: 'Please enter state/province',
    city: 'City',
    cityPlaceholder: 'Please enter city',
    postalCode: 'Postal Code',
    postalCodePlaceholder: 'Please enter postal code',
    addressDetail: 'Detailed Address',
    addressDetailPlaceholder: 'Please enter detailed address',
    contactPerson: 'Contact Person',
    contactPersonPlaceholder: 'Please enter contact person',
    contactPhone: 'Contact Phone',
    contactPhonePlaceholder: 'Please enter contact phone',
    status: 'Status',
    statusPlaceholder: 'Select status',
    save: 'Save',
    add: 'Add'
  },

  // Warehouse types
  warehouseTypes: {
    amazon: 'Amazon Warehouse',
    ecang: 'ECang',
    other: 'Other',
    factory: 'Factory Warehouse',
    fba: 'FBA Warehouse',
    thirdParty: '3PL Warehouse',
    selfOwned: 'Self-owned Warehouse',
    overseas: 'Overseas Warehouse',
    transit: 'Transit Warehouse',
    unknown: 'Unknown'
  },

  // Confirmation dialogs
  confirm: {
    enableItem: 'Are you sure to enable this warehouse?',
    disableItem: 'Are you sure to disable this warehouse?',
    batchEnable: 'Are you sure to enable the selected {count} warehouses?',
    batchDisable: 'Are you sure to disable the selected {count} warehouses?',
    batchDelete: 'Delete the selected {count} warehouses and their language versions? This action cannot be undone.',
    deleteItem: 'Delete warehouse "{name}"? This action cannot be undone.',
    deleteDraft: 'Delete this unsaved new warehouse?',
    copyWillCreateTaskTitle: 'Create Background Copy Task',
    copyWillCreateTaskContent: '{count} platform warehouse records are selected. Submitting will create a background task, and details can be viewed in Task Management.',
    copyWillCreateTaskOk: 'Create Task',
    copyTaskRedirectTitle: 'Go to Task Management',
    copyTaskRedirectContent: 'The background copy task has been submitted. You can view details in Task Management.',
    copyTaskRedirectOk: 'Go to Task Management'
  },

  // Form validation
  validation: {
    warehouseCodeRequired: 'Please enter warehouse code',
    warehouseCodeMinLength: 'Warehouse code must be at least 3 characters',
    warehouseTypeRequired: 'Please select warehouse type',
    warehouseNameCnRequired: 'Please enter Chinese warehouse name',
    warehouseNameEnRequired: 'Please enter English warehouse name',
    warehouseNameEnNoChinese: 'English warehouse name cannot contain characters from non-English scripts',
    countryRequired: 'Please select country',
    cityRequired: 'Please enter city',
    addressDetailRequired: 'Please enter detailed address',
    statusRequired: 'Please select status'
  },

  // Message prompts
  messages: {
    selectToEnable: 'Please select warehouses to enable',
    selectToDisable: 'Please select warehouses to disable',
    selectToDelete: 'Please select warehouses to delete',
    loadError: 'Failed to load warehouse data, please try again later',
    searchError: 'Search failed, please try again later',
    saveSuccess: 'Warehouse saved successfully',
    saveError: 'Failed to save, please try again later',
    updateSuccess: 'Warehouse updated successfully',
    updateError: 'Failed to update, please try again later',
    deleteSuccess: 'Warehouse deleted successfully',
    deleteError: 'Failed to delete warehouse, please try again later',
    finishEditingFirst: 'Please save or cancel the current editing row first',
    inlineRequired: 'Please complete all required fields in the current row',
    warehouseCodeDuplicate: 'The warehouse code already exists in the current tenant',
    statusToggleSuccess: 'Warehouse status updated successfully',
    statusToggleError: 'Failed to toggle status, please try again later',
    batchEnableSuccess: 'Enabled {count} warehouses',
    batchEnableError: 'Failed to batch enable, please try again later',
    batchDisableSuccess: 'Disabled {count} warehouses',
    batchDisableError: 'Failed to batch disable, please try again later',
    batchDeleteSuccess: 'Deleted {count} warehouses',
    batchDeleteError: 'Failed to batch delete, please try again later',
    formIncomplete: 'Please complete all required fields before saving or closing',
    platformLoadError: 'Failed to load platform warehouse data, please try again later',
    selectPlatformToCopy: 'Please select platform warehouses to copy',
    copySelectedSuccess: 'Copied {count} warehouses',
    copyAllSuccess: 'Copied {count} warehouses, skipped {skipped} existing warehouses',
    copyTaskSubmitted: 'Created warehouse background copy task (Task ID: {taskId}). Estimated {count} records. You can view details in Task Management.',
    copyTaskAlreadyRunning: 'A warehouse copy task is already running (Task ID: {taskId}). Please view details in Task Management.',
    copyError: 'Copy failed, please try again later'
  },

  platformCopy: {
    title: 'Copy Platform Warehouses',
    keywordPlaceholder: 'Search warehouse code, name, city',
    selectedTitle: 'Selected',
    selectedCount: '{count} selected',
    platformTitle: 'Platform Warehouses',
    platformCount: '{total} platform records, {available} available on this page',
    clearSelected: 'Clear',
    remove: 'Remove',
    restore: 'Restore',
    cancel: 'Cancel',
    copySelected: 'Copy Selected ({count})',
    copyAll: 'Copy All Filtered',
    selectAllFiltered: 'Select all {total} copyable matching records',
    querySelectedNotice: 'All {total} copyable records matching the current filters are selected. The left table does not list every record; uncheck rows on the right to exclude them. {excluded} excluded.',
    taskNotice: '{count} records selected. Submitting will create a background task, and details can be viewed in Task Management.',
    syncLimitNotice: '{count} records selected, exceeding the synchronous copy limit of {limit}. Please narrow the filters and try again.',
    excludedPreview: 'Excluded Details',
    copyStatus: 'Copy Status',
    exists: 'Existing',
    available: 'Available',
    allStatus: 'All',
    statusPlaceholder: 'Select copy status',
    copyAllConfirmTitle: 'Confirm Copy All Filtered',
    copyAllConfirmContent: 'This will copy warehouses that do not exist under the current filters. Existing warehouses will be skipped. Current filter has {count} platform records.'
  },

  batchImport: {
    title: 'Batch Import Warehouses',
    uploadStep: 'Upload File',
    previewStep: 'Parse & Preview',
    templateTip: 'Download the template and enter one warehouse per row with Chinese and English columns. Duplicate codes are merged, with later non-empty values taking precedence.',
    exampleNotice: 'The examples above are excluded from the final import. Please start entering data on the next row.',
    downloadTemplate: 'Download Template',
    uploadTip: 'Click or drag a warehouse import file here',
    fileLimit: 'Only .xlsx files are supported, up to 1,000 warehouses per import',
    parsing: 'Parsing',
    parse: 'Parse and Preview',
    totalCount: 'Warehouses',
    validCount: 'Importable',
    invalidCount: 'Invalid',
    sourceRows: 'Source Rows',
    result: 'Validation',
    valid: 'Valid',
    invalid: 'Invalid',
    errorReason: 'Error Details',
    previous: 'Previous',
    confirmImport: 'Import ({count})',
    dictionaryField: 'Field',
    dictionaryValue: 'Allowed Values / Description',
    countryCodeDescription: 'Enter a Chinese name, English name, or country code. It is fuzzy matched against current-tenant country master data; unmatched countries cannot be imported.',
    divisionDescription: 'Chinese and English values are matched under the resolved country. Either match backfills both names; if neither matches, the original Excel text is imported.',
    templateFilename: 'warehouse-batch-import-template.xlsx',
    downloadError: 'Failed to download the template. Please try again later.',
    requiredField: '{field} is required',
    maxLength: '{field} cannot exceed {max} characters',
    inconsistentMainFields: 'Main fields must be identical for rows with the same warehouse code',
    invalidWarehouseType: 'Invalid warehouse type value',
    invalidLocale: 'Only zh-CN and en-US are supported',
    warehouseCodeExists: 'The warehouse code already exists in the current tenant',
    invalidCountryCode: 'The country code is not in the current tenant country master data',
    invalidCountry: 'Country "{value}" was not found in current-tenant master data. New countries cannot be created by import.',
    countryAmbiguous: 'Country "{value}" matches multiple master records. Enter a more precise name or country code.',
    divisionAmbiguous: '{field} matches multiple master records. Enter a more precise name.',
    divisionConflict: 'The Chinese and English {field} values match different master records.',
    englishOnly: '{field} cannot contain characters from non-English scripts',
    sharedPostalConflict: 'Chinese and English rows for the same warehouse must use the same postal code in a legacy template',
    languageRequired: 'At least one valid language version is required',
    missingColumns: 'Missing fields in the import file: {columns}',
    noWorksheet: 'No readable worksheet was found in the import file',
    noRows: 'No importable rows were found in the import file',
    tooManyWarehouses: 'A single import supports up to {max} warehouses. Split the file and try again.',
    parseError: 'Failed to parse the file. Check the template format.',
    noValidRows: 'No valid warehouses to import. Correct the data and parse the file again.',
    partialImportTip: 'Only {validCount} valid warehouses will be imported; {invalidCount} invalid warehouses will be skipped. Correct and upload the invalid data again.',
    partialImportSuccess: 'Imported {count} warehouses successfully; skipped {skipped} invalid warehouses',
    importSuccess: 'Imported {count} warehouses successfully',
    importError: 'Failed to import warehouses. Check the data and try again.',
    columns: {
      warehouseCode: 'Warehouse Code*',
      warehouseNameCn: 'Warehouse Name* (Chinese)',
      warehouseNameEn: 'Warehouse Name* (English)',
      country: 'Country*',
      stateProvinceCn: 'State/Province (Chinese)',
      stateProvinceEn: 'State/Province (English)',
      cityCn: 'City (Chinese)',
      cityEn: 'City (English)',
      postalCode: 'Postal Code',
      warehouseType: 'Warehouse Type*',
      addressDetailCn: 'Detailed Address* (Chinese)',
      addressDetailEn: 'Detailed Address* (English)',
      contactNameCn: 'Warehouse Contact (Chinese)',
      contactNameEn: 'Warehouse Contact (English)',
      contactPhoneCn: 'Contact Phone (Chinese)',
      contactPhoneEn: 'Contact Phone (English)'
    },
    instructions: {
      warehouseCode: '[Required] One warehouse per row; identical codes are overwritten/merged; do not change the headers',
      warehouseNameCn: '[Required · Chinese] Enter the Chinese name; other languages are allowed in Chinese columns without language validation',
      warehouseNameEn: '[Required · English] Enter the English name; other languages are not allowed in English columns',
      country: '[Required · Shared] Chinese name/English name/code accepted; fuzzy match Countries; no new countries; matches backfill Chinese and English names',
      stateProvinceCn: '[Optional · Chinese] Enter a province-level name (e.g. Hung Yen Province); match Administrative Divisions; unmatched names can be created; no language validation',
      stateProvinceEn: '[Optional · English] Enter the province-level English name; Chinese is not allowed when provided; unmatched names can be created',
      cityCn: '[Optional · Chinese] Enter the subordinate city/county; do not put cities in State/Province; no language validation; new names can be created',
      cityEn: '[Optional · English] Enter the subordinate city/county in English; Chinese and other languages are not allowed when provided',
      postalCode: '[Optional · Shared] Shared by Chinese and English versions; use the local format',
      warehouseType: '[Required · Shared] Factory/FBA/3PL/Self-owned/Overseas/Transit Warehouse',
      addressDetailCn: '[Required · Chinese] Detailed address in Chinese; no language validation in Chinese columns',
      addressDetailEn: '[Required · English] Detailed address in English; Chinese and other languages are not allowed',
      contactNameCn: '[Optional · Chinese] Contact name in Chinese; no language validation in Chinese columns',
      contactNameEn: '[Optional · English] Contact name in English; Chinese and other languages are not allowed when provided',
      contactPhoneCn: '[Optional] Phone for the Chinese contact; no language validation; may be the same as the Chinese contact phone',
      contactPhoneEn: '[Optional] Phone for the English contact; no language validation; may be the same as the Chinese contact phone'
    }
  },

  languageVersion: {
    count: '{count} languages',
    title: 'Language Versions',
    add: 'Add Language',
    noData: 'No language versions',
    locale: 'Language',
    chinese: 'Chinese',
    english: 'English',
    country: 'Country',
    stateProvince: 'State/Province',
    city: 'City',
    postalCode: 'Postal Code',
    addressDetail: 'Detailed Address',
    contactName: 'Warehouse Contact',
    contactPhone: 'Contact Phone',
    operation: 'Actions',
    keepOne: 'At least one language version must be retained',
    localeDuplicate: 'Languages cannot be duplicated within the same warehouse',
    addressRequired: 'Please enter the detailed address for every language version',
    englishNoChinese: 'State/province, city, address, and contact in the English version cannot contain characters from non-English scripts'
  },

  // Status text
  statusText: {
    enabled: 'enabled',
    disabled: 'disabled'
  },

  // Country options
  countries: {
    US: 'United States',
    GB: 'United Kingdom',
    DE: 'Germany',
    FR: 'France',
    IT: 'Italy',
    ES: 'Spain',
    CA: 'Canada',
    AU: 'Australia',
    JP: 'Japan',
    KR: 'South Korea',
    SG: 'Singapore',
    TH: 'Thailand',
    MY: 'Malaysia',
    MX: 'Mexico',
    BR: 'Brazil'
  }
}
